import { Box, Image, Text } from '@zillow/constellation-10';

import SearchHomesSVG from '../../../../images/SearchHomes.svg';

const NotEnoughComps = () => (
  <Box
    css={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
  >
    <Image src={SearchHomesSVG} alt="" />
    <Text textStyle="body-sm" css={{ color: 'text.subtle', marginTop: '400' }}>
      Not enough information available
    </Text>
  </Box>
);

export default NotEnoughComps;
